// @ts-nocheck
import { VERIFY_EMAIL_ERROR, VERIFY_EMAIL_LOADING, VERIFY_EMAIL_SUCCESS} from "../../Action/Type";

const initialState = {
    payload: {},
    loading: false,
    error: ''
}

export const VerifyEmailReducer = (state = initialState, action) => {
    switch (action.type) {
        case VERIFY_EMAIL_LOADING:
            return Object.assign({}, state, { loading: true })
        case VERIFY_EMAIL_SUCCESS:
            return Object.assign({}, state, { payload: action.data, loading: false })
        case VERIFY_EMAIL_ERROR:
            return Object.assign({}, state, { payload: action.data, loading: false })
        default:
            return state
    }
}

